// Old AMD key: `ac/spa-context`

// TODO: we will improve the type later when we know the code better.
type ApiType = {
	navigate?: (url: string, goTo?: () => void) => void;
};

let containerApi: ApiType | null = null;
let navigationApi: ApiType | null = null;

export const provideContainerApi = (api: ApiType): void => {
	containerApi = api;
};

export const provideNavigationApi = (api: ApiType): void => {
	navigationApi = api;
};

export const isInIframe = () => containerApi !== null;

export const canSpaTransition = () => navigationApi !== null;

export const getContainerApi = () => containerApi;

export const getNavigationApi = () => navigationApi;

export const resetSpaContext = () => {
	containerApi = null;
	navigationApi = null;
};
